import {AxiosError, AxiosProgressEvent} from 'axios';

import {Completable, DocumentDTO, KashableResponseDTO, QueueDTO, UnderwritingContext} from 'kashable-mobile-common';

import {AdditionalDocumentType} from '../hooks/useDocuments';
import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const fetchQueues: (uec:UnderwritingContext | undefined) => Promise<Completable<Array<QueueDTO>>> = (uec:UnderwritingContext | undefined) => {
    // only forward PREQUALIFY. If it's not PREQUALIFY, the server will know how to select the correct one
    // eslint-disable-next-line
    const params:any = {};
    if(uec === 'PREQUALIFY'){
        params.uec = uec;
    }

    return axios
        .get<KashableResponseDTO<Array<QueueDTO>>>('/secured/user/queue', {params})
        .then((res) => mapSucceeded(res, (d) => d.data || []))
        .catch((error: AxiosError<string>) => errored(error));
};

const uploadQueueFile: (
    formData: FormData,
    type: AdditionalDocumentType,
    docType: AdditionalDocumentType | '',
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
) => Promise<Completable<Array<DocumentDTO>>> = (
    formData: FormData,
    type: AdditionalDocumentType,
    docType: AdditionalDocumentType | '',
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
) => {
    return axios
        .post<KashableResponseDTO<Array<DocumentDTO>>>(
            `/secured/user/document/queue/${type}/${docType}`,
            formData,
            {
                headers: {
                    'Content-type': 'multipart/form-data',
                },
                onUploadProgress,
            },
        )
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const uploadQueueFileBefore: (type: AdditionalDocumentType) => Promise<Completable<boolean>> = (
    type: AdditionalDocumentType,
) => {
    return axios
        .post<KashableResponseDTO<boolean>>(`/secured/user/action/queue/${type.toLowerCase()}/upload`)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const uploadQueueFileAfter: (type: AdditionalDocumentType) => Promise<Completable<boolean>> = (
    type: AdditionalDocumentType,
) => {
    return axios
        .post<KashableResponseDTO<boolean>>(`/secured/user/event/queue/${type.toLowerCase()}/upload/complete`)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const uploadQueueAllotmentError: () => Promise<Completable<boolean>> = () => {
    return axios
        .post<KashableResponseDTO<boolean>>('/secured/user/event/queue/allotment/error')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {fetchQueues, uploadQueueFile, uploadQueueFileBefore, uploadQueueFileAfter, uploadQueueAllotmentError};
